document.addEventListener('DOMContentLoaded', function () {

  // Only run on mobile
  if (window.innerWidth <= 1024) {
    const bannerWrapper = document.querySelector(".dots-banner-section--wrapper");

    if (bannerWrapper) {
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--theme-header-height')) || 0;
      const storeMsgHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--theme-storemsg-height')) || 0;
      const announcementBarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--theme-announcmentBar-height')) || 0;

      const isFirstSection = bannerWrapper.classList.contains("is-first-section");

      let height = window.innerHeight;

      if (isFirstSection) {
        height = height - headerHeight - storeMsgHeight - announcementBarHeight;
      }

      bannerWrapper.style.height = `${height}px`;

      const scrollableBlocks = bannerWrapper.querySelectorAll('.dots-banner-wrapper > .shopify-block');

      scrollableBlocks.forEach(scrollBlock => {
        if (scrollBlock.scrollWidth > scrollBlock.clientWidth) {
          scrollBlock.style.scrollBehavior = 'auto';
          const scrollAmount = (scrollBlock.scrollWidth - scrollBlock.clientWidth) / 2;
          scrollBlock.scrollLeft = scrollAmount;
        }
      });
      bannerWrapper.style.opacity = 1
    }
  }
  
  // Initialize each dots banner section separately
  function initializeDotsBannerSection(sectionWrapper, sectionId) {
    const pulses = sectionWrapper.querySelectorAll('.pulse');
    
    // Hide all tags within this specific section only
    function hideAllTagsInSection() {
      pulses.forEach(pulse => {
        const innerCircle = pulse.querySelector('.inner-circle');
        const tag = pulse.querySelector('.product_tag');
        if (tag && innerCircle) {
          tag.classList.remove('visible-tag');
          innerCircle.classList.remove('hidden-dot');
        }
      });
    }

    // Attach click handler to each dot within this section
    pulses.forEach(pulse => {
      const innerCircle = pulse.querySelector('.inner-circle');
      const tag = pulse.querySelector('.product_tag');

      if (innerCircle && tag) {
        innerCircle.addEventListener('click', function (e) {
          e.stopPropagation();
          // Hide all others in this section only
          hideAllTagsInSection();
          
          // Show current
          tag.classList.add('visible-tag');
          innerCircle.classList.add('hidden-dot');
        });
      }
    });

    // Handle clicks outside this section
    document.addEventListener('click', function (e) {
        hideAllTagsInSection();
    });

    // Handle Swiper initialization for this section
    const wrapper = sectionWrapper.querySelector('.dots-banner-wrapper');
    const swiperContainer = sectionWrapper.querySelector('.dots-banner-section');
    
    if (wrapper && swiperContainer) {
      // Add swiper-slide class to direct children
      const directChildren = wrapper.querySelectorAll(':scope > .shopify-block');
      directChildren.forEach(el => {
        el.classList.add('swiper-slide');
      });

      // Initialize Swiper with unique class for this section
      const uniqueSwiperClass = `mySwiper-${sectionId}`;
      swiperContainer.classList.add(uniqueSwiperClass);
      
      new Swiper(`.${uniqueSwiperClass}`, {
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: sectionWrapper.querySelector('.swiper-button-next'),
          prevEl: sectionWrapper.querySelector('.swiper-button-prev'),
        },
      });
    }
  }

  // Find all dots banner sections and initialize them
  const dotsBannerSections = document.querySelectorAll('.dots-banner-section--wrapper');
  
  dotsBannerSections.forEach((sectionWrapper, index) => {
    // Extract section ID from class name or use index as fallback
    const classList = Array.from(sectionWrapper.classList);
    let sectionId = classList.find(cls => cls.startsWith('dots-banner-section--') && cls !== 'dots-banner-section--wrapper');
    
    if (sectionId) {
      sectionId = sectionId.replace('dots-banner-section--', '');
    } else {
      sectionId = `section-${index}`;
      sectionWrapper.classList.add(`dots-banner-section--${sectionId}`);
    }
    
    initializeDotsBannerSection(sectionWrapper, sectionId);
  });
});

// Alternative approach if sections are added dynamically after page load
// You can call this function whenever a new section is added
function initializeNewDotsBannerSection(sectionElement) {
  if (!sectionElement.classList.contains('dots-banner-section--wrapper')) {
    console.warn('Element is not a dots banner section wrapper');
    return;
  }
  
  // Generate unique ID for this section
  const existingSections = document.querySelectorAll('.dots-banner-section--wrapper');
  const sectionId = `dynamic-section-${existingSections.length}`;
  sectionElement.classList.add(`dots-banner-section--${sectionId}`);
  
  initializeDotsBannerSection(sectionElement, sectionId);
}

// Export for potential external use
window.initializeNewDotsBannerSection = initializeNewDotsBannerSection;